import React from "react";


export const RulerContext = React.createContext({
    stroke: "black",
    fontSize: 62,
});
